import { ISupportingFile } from 'app/models/supportingFile';

/**
 * Data shape for Add Customer wizard — Request Details step (Step 1).
 */
export interface IAddCustomerRequestDetails {
    description: string;
    cssCaseNumber: string;
    confidentialIdentifiers: string;
    supportingFiles: ISupportingFile[];
}

export type IFileInfo = ISupportingFile;

export const INITIAL_ADD_CUSTOMER_REQUEST_DETAILS: IAddCustomerRequestDetails = {
    description: '',
    cssCaseNumber: '',
    confidentialIdentifiers: '',
    supportingFiles: [],
};

export const ADD_CUSTOMER_DESCRIPTION_MAX_LENGTH = 10000;

export const getDescriptionText = (description?: string, trim = true): string => {
    if (!description) return '';
    const document = new DOMParser().parseFromString(description, 'text/html');
    document.body.querySelectorAll('script, style, template').forEach(node => node.remove());
    const text = (document.body.textContent || '').replace(/\u00a0/g, ' ');
    return trim ? text.trim() : text;
};

export const hasDescriptionContent = (description?: string): boolean => {
    if (getDescriptionText(description)) return true;
    const document = new DOMParser().parseFromString(description || '', 'text/html');
    return Array.from(document.body.querySelectorAll('img')).some(image => !!image.getAttribute('src')?.trim());
};

// RequestType API values: CSSRequest=6, CssReviewRequest=7, CXP_TechnicalRequest=11.
const CSS_CASE_REQUEST_TYPES = new Set([6, 7, 11]);

export const requiresCssCaseNumber = (requestType?: number): boolean =>
    requestType != null && CSS_CASE_REQUEST_TYPES.has(requestType);
